import BrandingModel from "../../../../Global/Models/Branding/BrandingModel";
import ImagesModel from "../../../../Global/Models/Images/ImagesModel";
import RelatedEntityRelationship from "../../../../Global/Models/Related/RelatedEntityRelationship";
import { AuthRequirementType } from "../../../../Global/Types/GlobalTypes";
import MiniGamesContext from "../MiniGamesContext";

export default class PersonalityQuizBasicModel {
  public id: string = null;
  public title: string = null;
  public alternativeTitle: string | null = null;
  public description: string | null = null;
  public images: ImagesModel | null = new ImagesModel();
  public participationCount: number = null;
  public status: string = null;
  public language: string | null = null;
  public authRequirement: AuthRequirementType | null = null;
  public flags: string[] = null;
  public customFields: Record<string, string> | null = null;
  public labels: Record<string, string> | null = null;
  public branding: BrandingModel | null = null;
  public related: RelatedEntityRelationship[] = [];
  public time: number = null;
  public preferencesEnabled: boolean = false;
  public maxAttempts: number = null;
  public adContent: string | null = null;
  public context: MiniGamesContext | null = null;
  public createdAt: string = null;
  public updatedAt: string = null;
}
